// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Error Component Styles */
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  padding: 20px;
  text-align: center;
  background-color: #f8f9fa;
}

.error-content {
  max-width: 500px;
  width: 100%;
  padding: 30px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #eaeaea;
  animation: fadeIn 0.5s ease-out;
}

.error-icon {
  font-size: 60px;
  margin-bottom: 20px;
  animation: bounce 1s infinite alternate;
}

.error-title {
  font-size: 24px;
  font-weight: 600;
  color: #d32f2f;
  margin: 0 0 15px;
}

.error-message {
  color: #5f6368;
  font-size: 16px;
  line-height: 1.5;
  margin: 0 0 25px;
}

.error-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.error-retry-button {
  background: #1a73e8;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.error-retry-button:hover {
  background: #1669d9;
  transform: translateY(-2px);
}

.error-home-button {
  background: white;
  color: #1a73e8;
  border: 1px solid #1a73e8;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.error-home-button:hover {
  background: #f1f8ff;
  transform: translateY(-2px);
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes bounce {
  from { transform: translateY(0); }
  to { transform: translateY(-10px); }
}

/* Responsive styles */
@media (max-width: 600px) {
  .error-content {
    padding: 20px;
  }
  
  .error-actions {
    flex-direction: column;
    gap: 10px;
  }
  
  .error-retry-button,
  .error-home-button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ErrorComponent.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,KAAK,4BAA4B,EAAE;AACrC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* Error Component Styles */\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 70vh;\n  padding: 20px;\n  text-align: center;\n  background-color: #f8f9fa;\n}\n\n.error-content {\n  max-width: 500px;\n  width: 100%;\n  padding: 30px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  border: 1px solid #eaeaea;\n  animation: fadeIn 0.5s ease-out;\n}\n\n.error-icon {\n  font-size: 60px;\n  margin-bottom: 20px;\n  animation: bounce 1s infinite alternate;\n}\n\n.error-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #d32f2f;\n  margin: 0 0 15px;\n}\n\n.error-message {\n  color: #5f6368;\n  font-size: 16px;\n  line-height: 1.5;\n  margin: 0 0 25px;\n}\n\n.error-actions {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.error-retry-button {\n  background: #1a73e8;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.error-retry-button:hover {\n  background: #1669d9;\n  transform: translateY(-2px);\n}\n\n.error-home-button {\n  background: white;\n  color: #1a73e8;\n  border: 1px solid #1a73e8;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.error-home-button:hover {\n  background: #f1f8ff;\n  transform: translateY(-2px);\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes bounce {\n  from { transform: translateY(0); }\n  to { transform: translateY(-10px); }\n}\n\n/* Responsive styles */\n@media (max-width: 600px) {\n  .error-content {\n    padding: 20px;\n  }\n  \n  .error-actions {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .error-retry-button,\n  .error-home-button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
